import type {GiftCardData} from '~/types/gift-card.types';

/**
 * Composable to manage gift card state across pages
 */
export const useGiftCard = () => {
    const giftCardData = useState<GiftCardData>('giftCardData', () => {
        return {
            amount: 0,
        }
    });
    const setAmount = (amount: number) => {
        giftCardData.value.amount = amount;
    };
    const setRecipient = (recipient: GiftCardData['recipient']) => {
        giftCardData.value.recipient = recipient;
    };
    const setBilling = (billing: GiftCardData['billing']) => {
        giftCardData.value.billing = billing;
    };

    const saveToLocalStorage = () => {
        window?.localStorage?.setItem('clemkerato-giftcard', JSON.stringify(giftCardData.value));
    }
    const reset = () => {
        giftCardData.value = {
            amount: 0,
        };
        window?.localStorage?.removeItem('clemkerato-giftcard');
    };

    return {
        giftCardData,
        setAmount,
        setRecipient,
        setBilling,
        reset,
        saveToLocalStorage,
    };
};
